import { initialState } from "./state"

export const setCampaign = (state, payload) => {
  if (payload && payload.providerRuleChains) {
    payload.providerRuleChains.sort((a, b) => a.order - b.order)
  }
  state.campaign = payload
}

export const setCampaigns = (state, payload) => {
  state.campaigns = payload
}

export const setTargets = (state, payload) => {
  state.targets = payload
}

export const resetTargets = (state) => {
  state.targets = null
}

export const setTargetDetail = (state, payload) => {
  state.targetDetail = payload
}

export const resetTargetDetail = (state) => {
  state.targetDetail = null
}

export const setRuleChains = (state, payload) => {
  state.ruleChains = payload
}

export const setAdvertisers = (state, payload) => {
  state.advertisers = payload?.filter((ad) => typeof ad === "string" && ad.trim() !== "")
}

export const resetAdvertisers = (state) => {
  state.advertisers = []
}

export const setInventory = (state, payload) => {
  state.inventory = payload
}

export const resetInventory = (state) => {
  state.inventory = null
}

export const setReports = (state, payload) => {
  state.reports = payload
}

export const resetReports = (state) => {
  state.reports = null
}

export const setAdvertisingDetails = (state, payload) => {
  state.advertisingDetails = payload
}

export const resetAdvertisingDetails = (state) => {
  state.advertisingDetails = null
}

export const setAdvertisingEnabled = (state, payload) => {
  state.isAdvertisingEnabled = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
